import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService:AuthService, 
    private router:Router
  ) {}
  
  canActivate(
    next: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    let url0 = next.url[0] ? next.url[0].path : undefined;
    // let url1 = next.url[1] ? next.url[1].path : undefined;
    // let url2 = next.url[2] ? next.url[2].path : undefined;
    // let url3 = next.url[3] ? next.url[3].path : undefined;
    
    let user = this.authService.user$.value;
    var allowed = false;
    switch (url0) {
      case "admin":
        allowed = user? user.account_type == "catadmin" : null;
        break;
      case "account":
        allowed = user? user.account_type == "customer" : null;
        break;
      default:
        allowed = false;
        break;
    }


    //Allow, or redirect to homepage
    if(allowed){
      return true;
    } else {
      //access denied
      // console.log(user);
      console.log('not allowed');
      this.router.navigate(['/']);
      return false;
    }
  }
}


//Unused Code

    // next: ActivatedRouteSnapshot,
    // state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // return true;

      // let url = state.url.replace('/','');
    // let url = state.url; //state provides the full url as a string.  But better to have url as segments to analyze for admin and account
    // let user = this.authService.user$.value;
    // var allowed = false;
    // switch (url) {
    //   case "/admin":
    //   case '/admin/products':
    //   case '/admin/products/edit/':
    //   case '/admin/customers':
    //     allowed = user? user.account_type == "catadmin" : null;
    //     break;
    //   case "/account":
    //   case "/account/profile":
    //   case "/account/orders":
    //   case "/account/reviews":
    //     allowed = user? user.account_type == "customer" : null;
    //     break;
    //   default:
    //     allowed = false;
    //     break;
    // }




// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts